import { Weekday } from './types';

const WEEKDAY_NAMES = {
    [Weekday.Monday]: 'понедельник',
    [Weekday.Tuesday]: 'вторник',
    [Weekday.Wednesday]: 'среда',
    [Weekday.Thursday]: 'четверг',
    [Weekday.Friday]: 'пятница',
    [Weekday.Saturday]: 'суббота',
    [Weekday.Sunday]: 'воскресенье',
    [Weekday.Sunday_Zero]: 'воскресенье',
} as const;

export const getWeekdayName = (weekday: Weekday) => WEEKDAY_NAMES[weekday];

const WEEKDAY_SHORT_NAMES = {
    [Weekday.Monday]: 'пн',
    [Weekday.Tuesday]: 'вт',
    [Weekday.Wednesday]: 'ср',
    [Weekday.Thursday]: 'чт',
    [Weekday.Friday]: 'пт',
    [Weekday.Saturday]: 'сб',
    [Weekday.Sunday]: 'вс',
    [Weekday.Sunday_Zero]: 'вс',
} as const;

export const getWeekdayShortName = (weekday: Weekday) => WEEKDAY_SHORT_NAMES[weekday];

const MONTHS = ['янв', 'фев', 'мар', 'апр', 'май', 'июнь', 'июль', 'авг', 'сен', 'окт', 'ноя', 'дек'] as const;

export const getMonthName = (month: number) => MONTHS[month];
